export function LayerObjectHelpers (pEditor, pLayer)
{
  function isRangeElementPositionAbsolute (isIgnoreRangeOffset)
  {
    var currentSelection = pEditor.range.selection.getCurrent();
    var currentRange = pEditor.range.getCurrent();
    var currentRangeStart, currentRangeEnd, startParentBlockElement, endParentBlockElement, currentElement;
    var ret = null;

    if (currentSelection && currentRange)
    {
      if (BEditor.browser.isIE)
      {
        if (currentSelection.type.toUpperCase() == 'CONTROL' && currentRange.length == 1 &&
           (currentRange.item(0).nodeName.toUpperCase() == 'IMG' || currentRange.item(0).nodeName.toUpperCase() == 'DIV') &&
            pEditor.$Style(currentRange.item(0), 'position').toLowerCase() == 'absolute')
        {
          ret = currentRange.item(0);
        }
        else if (pEditor.image.currentImage && pEditor.$Style(pEditor.image.currentImage, 'position').toLowerCase() == 'absolute')
        {
          ret = pEditor.image.currentImage;
        }
        else if (currentSelection.type.toUpperCase() != 'CONTROL')
        {
          currentRangeStart = currentRange.duplicate();
          currentRangeStart.collapse(true);
          currentRangeEnd = currentRange.duplicate();
          currentRangeEnd.collapse(false);
          startParentBlockElement = pEditor.findParentAbsElement(pEditor.helpers.element.getParentElementByTagsNames(currentRangeStart, pEditor.checkDivImgTags));
          endParentBlockElement = pEditor.findParentAbsElement(pEditor.helpers.element.getParentElementByTagsNames(currentRangeEnd, pEditor.checkDivImgTags));

          if (startParentBlockElement && endParentBlockElement && startParentBlockElement == endParentBlockElement)
          {
            ret = startParentBlockElement;
          }
        }
      }
      else
      {
        if ((currentElement = pEditor.image.getCurrentImage()) && pEditor.$Style(currentElement, 'position').toLowerCase() == 'absolute')
        {
          ret = currentElement;
        }
        else if (currentRange.startContainer == currentRange.endContainer && currentRange.endOffset - currentRange.startOffset == 1 && currentRange.startContainer.hasChildNodes())
        {
          currentElement = currentRange.startContainer.childNodes[currentRange.startOffset];

          if (currentElement && (currentElement.nodeName.toUpperCase() == 'IMG' || currentElement.nodeName.toUpperCase() == 'DIV') && pEditor.$Style(currentElement, 'position').toLowerCase() == 'absolute')
          {
            if (currentElement.nodeName.toUpperCase() == 'DIV' && !currentElement.getAttribute('data-waelementhidecursor'))
            {
              ret = currentElement;
            }
            else if (pLayer.currentAbsElement)
            {
              ret = pLayer.currentAbsElement;
            }
          }
        }
        else
        {
          startParentBlockElement = pEditor.findParentAbsElement(pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkDivImgTags));
          endParentBlockElement = pEditor.findParentAbsElement(pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkDivImgTags));

          if (startParentBlockElement && endParentBlockElement && startParentBlockElement == endParentBlockElement)
          {
            if (startParentBlockElement.nodeName.toUpperCase() == 'DIV' && !startParentBlockElement.getAttribute('data-waelementhidecursor'))
            {
              ret = startParentBlockElement;
            }
            else if (pLayer.currentAbsElement)
            {
              ret = pLayer.currentAbsElement;
            }
          }
        }
      }
    }

    return ret;
  }
  
  
  this.normalizeAbsElement = () =>
  {
    var inHTML;
    var rangeElement = isRangeElementPositionAbsolute();
    var elementsBR;

    if (isGecko && rangeElement && rangeElement.nodeName.toUpperCase() == 'DIV')
    {
      inHTML = rangeElement.innerHTML;

      if (inHTML.replace(/(<br>|\s|&nbsp;)+/ig, '') == '')
      {
        rangeElement.innerHTML = (BEditor.browser.isIE) ? '&nbsp;' : '<br>';
      }
      else if (inHTML.match(/(<br>|&nbsp;)$/))
      {
        elementsBR = rangeElement.getElementsByTagName('BR');

        if (elementsBR && elementsBR.length > 0)
        {
          elementsBR[elementsBR.length - 1].parentNode.removeChild(elementsBR[elementsBR.length - 1]);
        }
      }
    }
  };
  
  
  this.setAbsElementZIndexCounter = () =>
  {
    var minMaxZIndex = getMinMaxZIndex();

    pLayer.coAbsElementZIndex = minMaxZIndex.maxZ + 1;

    return minMaxZIndex;
  };
  
  
  function getMinMaxZIndex ()
  {
    var i,
      elements,
      elementZIndex,
      minZIndex = null,
      maxZIndex = null;

    elements = pEditor.iFrameDoc.body.getElementsByTagName('*');

    for (i = 0; i < elements.length; i++)
    {
      if ((elements[i].nodeName.toUpperCase() === 'IMG' || elements[i].nodeName.toUpperCase() === 'DIV') && pEditor.$Style(elements[i], 'position') === 'absolute')
      {
        elementZIndex = pEditor.$StyleStrictInt(elements[i], 'zIndex');

        if (elementZIndex !== null)
        {
          if (elementZIndex < minZIndex || minZIndex === null)
          {
            minZIndex = elementZIndex;
          }

          if (elementZIndex > maxZIndex || maxZIndex === null)
          {
            maxZIndex = elementZIndex;
          }
        }
      }
    }

    return {minZ: ((minZIndex !== null ) ? minZIndex : 100), maxZ: ((maxZIndex !== null) ? maxZIndex : 100)};
  }


  this.removeEmptyAbsElements = () =>
  {
    var i = 0;
    var elements = pEditor.iFrameDoc.body.getElementsByTagName('DIV');

    if (elements && elements.length > 0)
    {
      pEditor.undoRedo.isStopSaveUndo = true;
      pEditor.contentChecker.setExcludeWordCheck();

      while (i < elements.length)
      {
        if (isAbsElementEmpty(elements[i]))
        {
          elements[i].parentNode.removeChild(elements[i]);
        }
        else
        {
          i++;
        }
      }

      pEditor.undoRedo.saveUndoDo(true);
      pEditor.undoRedo.isStopSaveUndo = false;
    }
  };


  function isAbsElementEmpty (element)
  {
    return (!element.id && element.getAttribute('data-autoabs', 0) && pEditor.$Style(element, 'position') == 'absolute' && element.innerHTML.replace(/(<br(?:\s[^>]*>|>)|\s|&nbsp;)+/ig, '') == '');
  }
  
  
  this.isRangeElementPositionAbsolute = isRangeElementPositionAbsolute;
  this.getMinMaxZIndex = getMinMaxZIndex;
}